<div class="dashboards-result">
  <ng-container *ngIf="detail() as dashboard; else list">
    <app-dashboard-detail [dashboard]="dashboard"></app-dashboard-detail>
  </ng-container>

  <ng-template #list>
    <div class="table-wrapper" *ngIf="dashboards().length > 0">
      <ui-dataset-table [data]="dashboards()" [config]="tableConfig()"></ui-dataset-table>
    </div>

    <div *ngIf="dashboards().length === 0" class="empty-state">
      {{ 'DASHBOARDS_RESULT.EMPTY_STATE' | translate }}
    </div>
  </ng-template>
</div>
